import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./auth/ProtectedRoute";
import AdminLayout from "./layout/AdminLayout";
import Login from "./pages/auth/Login";
import Dashboard from "./pages/dashboard/Dashboard";
import Users from "./pages/auth/Users";
import UsersAdminList from "./pages/users/UsersAdminList";

import PromoLayout from "./pages/promo/PromoLayout";
import PromoAdminList from "./pages/promo/PromoAdminList";
import PromoValidate from "./pages/promo/PromoValidate";
import PromoRedeem from "./pages/promo/PromoRedeem";
import PromoUpsertPage from "./pages/promo/PromoUpsertPage";
import TargetedPromoAdminList from "./pages/promo/TargetedPromoAdminList";
import TargetedPromoUpsertPage from "./pages/promo/TargetedPromoUpsertPage";

import CourtesyVoucherAdminList from "./pages/courtesy/CourtesyVoucherAdminList";

import CmsPagesList from "./pages/cms/CmsPagesList";
import CmsPageForm from "./pages/cms/CmsAdminForm";

import PolicyPagesList from "./pages/policyPages/PolicyPagesList";
import PolicyPageForm from "./pages/policyPages/PolicyPageForm";


import FaqAdminList from "./pages/faq/FaqAdminList";
import FaqAdminCreate from "./pages/faq/FaqAdminCreate";
import FaqAdminEdit from "./pages/faq/FaqAdminEdit";

import SocialLoginSettingsPage from "./pages/settings/SocialLoginSettingsPage";
import SocialLoginProvidersPage from "./pages/settings/SocialLoginProvidersPage";
import SocialProviderSettingsPage from "./pages/settings/SocialProviderSettingsPage";
import AppSettingsPage from "./pages/settings/AppSettingsPage";
import DynamicLinksSettingsPage from "./pages/settings/DynamicLinksSettingsPage";

import BookingsList from "./pages/bookings/BookingsList";
import CreateBookingFromTbo from "./pages/bookings/CreateBookingFromTbo";
import BookingAttemptsList from "./pages/bookingAttempts/BookingAttemptsList";
import BookingAttemptDetailPage from "./pages/bookingAttempts/BookingAttemptDetailPage";
import CreditLineList from "./pages/creditLine/CreditLineList";
import CreditLineIssue from "./pages/creditLine/CreditLineIssue";
import CreditLineView from "./pages/creditLine/CreditLineView";
import WalletActionList from "./pages/walletAction/WalletActionList";
import BookingViewEditPage from "./pages/bookings/BookingViewEditPage";
import BookingPaymentsList from "./pages/bookings/BookingPaymentsList";
import BookingInvoiceList from "./pages/bookings/BookingInvoiceList";

import GiftCardManagementList from "./pages/giftcardmanagement/GiftCardManagementList";
import GiftCardManagementForm from "./pages/giftcardmanagement/GiftCardManagementForm";
import GiftCardsList from "./pages/giftcardmanagement/GiftCardsList";
import GiftCardRefundsList from "./pages/bookings/GiftCardRefunds";

import PushNotificationLog from "./pages/pushNotification/PushNotificationLog";

import MenusAdminList       from "./pages/menus/MenusAdminList";
import RolesAdminList       from "./pages/roles/RolesAdminList";
import PermissionsAdminList from "./pages/permissions/PermissionsAdminList";

import AdminUsersList from "./pages/users/AdminUsersList";
import OrgOverview from "./pages/users/OrgOverview";
import OrgAuditLog from "./pages/users/OrgAuditLog";
import PermissionGuard from "./auth/PermissionGuard";

import TicketsPage from "./pages/tickets/TicketsPage";
import TicketViewPage from "./pages/tickets/TicketViewPage";
import SupportPage from "./pages/support/SupportPage";

import ForgotPassword from "./pages/auth/ChangePassword"
import ResetPassword from "./pages/auth/ResetForgotPassword";
import SetPassword from "./pages/auth/SetPassword";

import TransitVisaAdminList  from "./pages/transitVisa/Transitvisaadminlist";
import TransitVisaUpsertPage from "./pages/transitVisa/Transitvisaupsertpage";
import IndianVisaAdminList   from "./pages/indianVisa/IndianVisaAdminList";
import IndianVisaUpsertPage  from "./pages/indianVisa/IndianVisaUpsertPage";
import TlLeaveList       from "./pages/users/TlLeaveList";
import TlLeaveUpsertPage from "./pages/users/TlLeaveUpsertPage";
import SuperadminGuard from "./auth/SuperadminGuard";
import MediaManager from "./pages/media/MediaManager";
import PngToGifConverter from "./pages/media/PngToGifConverter";
import CityImageList   from "./pages/cityImages/CityImageList";
import CityImageUpload from "./pages/cityImages/CityImageUpload";
import CityImageEdit   from "./pages/cityImages/CityImageEdit";
import PopularDestinationList       from "./pages/popularDestinations/PopularDestinationList";
import PopularDestinationUpsertPage from "./pages/popularDestinations/PopularDestinationUpsertPage";
import MyProfile from "./pages/profile/MyProfile";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/support" element={<SupportPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password"  element={<ResetPassword />} />
        <Route path="/set-password" element={<SetPassword />} />
        <Route path="/" element={ <ProtectedRoute> <AdminLayout /> </ProtectedRoute> } >
          <Route index element={<Dashboard />} />
          <Route path="users" element={<UsersAdminList />} />
          <Route path="admin/promo-codes" element={<PromoLayout />}>
          <Route index element={<PromoAdminList />} />
          <Route path="validate" element={<PromoValidate />} />
          <Route path="redeem" element={<PromoRedeem />} />
          </Route>
          
          <Route path="courtesy-voucher" element={<CourtesyVoucherAdminList />} />
          <Route path="admin/promo-codes/create" element={<PromoUpsertPage />} />
          <Route path="admin/promo-codes/edit/:promoId" element={<PromoUpsertPage />} />

          <Route path="admin/targeted-promo-codes" element={<PermissionGuard slug="targeted-promo-codes"><TargetedPromoAdminList /></PermissionGuard>} />
          <Route path="admin/targeted-promo-codes/create" element={<PermissionGuard slug="targeted-promo-codes"><TargetedPromoUpsertPage /></PermissionGuard>} />
          <Route path="admin/targeted-promo-codes/edit/:promoId" element={<PermissionGuard slug="targeted-promo-codes"><TargetedPromoUpsertPage /></PermissionGuard>} />

          <Route path="/admin/cms-pages" element={<CmsPagesList />} />
          <Route path="/admin/cms-pages/create" element={<CmsPageForm />} />
          <Route path="/admin/cms-pages/edit/:cms_page_id" element={<CmsPageForm />} />

          <Route path="/admin/policy-pages" element={<PermissionGuard slug="policy-pages"><PolicyPagesList /></PermissionGuard>} />
          <Route path="/admin/policy-pages/create" element={<PermissionGuard slug="policy-pages"><PolicyPageForm /></PermissionGuard>} />
          <Route path="/admin/policy-pages/edit/:policy_page_id" element={<PermissionGuard slug="policy-pages"><PolicyPageForm /></PermissionGuard>} />

          <Route path="/admin/faqs" element={<FaqAdminList />} />
          <Route path="/admin/faqs/create" element={<FaqAdminCreate />} />
          <Route path="/admin/faqs/edit/:slug" element={<FaqAdminEdit />} />

          {/* <Route path="/admin/settings/social-login" element={<SocialLoginSettingsPage />} /> */}
          <Route path="/admin/settings-management" element={<SocialLoginProvidersPage />} />
          <Route path="/admin/settings-management/:provider" element={<SocialProviderSettingsPage />} />
          <Route path="/admin/settings/app-settings" element={<AppSettingsPage />} />
          <Route path="/admin/settings/dynamic-links" element={<DynamicLinksSettingsPage />} />

          <Route path="admin/bookings" element={<BookingsList />} />
          <Route path="admin/bookings/create" element={<CreateBookingFromTbo />} />
          <Route path="admin/bookings/edit/trace/:traceId" element={<BookingViewEditPage />} />

          <Route path="/admin/booking-attempts" element={<PermissionGuard slug="booking-attempts"><BookingAttemptsList /></PermissionGuard>} />
          <Route path="/admin/booking-attempts/:traceId" element={<PermissionGuard slug="booking-attempts"><BookingAttemptDetailPage /></PermissionGuard>} />

          <Route path="/admin/credit-lines" element={<PermissionGuard slug="credit-lines"><CreditLineList /></PermissionGuard>} />
          <Route path="/admin/credit-lines/issue" element={<PermissionGuard slug="credit-lines"><CreditLineIssue /></PermissionGuard>} />
          <Route path="/admin/credit-lines/:id" element={<PermissionGuard slug="credit-lines"><CreditLineView /></PermissionGuard>} />
          <Route path="/admin/wallet-action" element={<PermissionGuard slug="wallet-action"><WalletActionList /></PermissionGuard>} />
          <Route path="admin/bookings/edit/:bookingId" element={<BookingViewEditPage />} />
          <Route path="admin/booking-payments" element={<BookingPaymentsList />} />
          <Route path="admin/booking-invoices" element={<BookingInvoiceList />} />

          <Route path="/admin/gift-card-management" element={<GiftCardManagementList />} />
          <Route path="/admin/gift-card-management/create" element={<GiftCardManagementForm />} />
          <Route path="/admin/gift-card-management/edit/:id" element={<GiftCardManagementForm />} />

          <Route path="/admin/gift-cards" element={<GiftCardsList />} />

          <Route path="/admin/booking-gift-card-refunds" element={<GiftCardRefundsList />} />
          
          <Route path="/admin/push-notification-log" element={<PushNotificationLog />} />

          <Route path="/admin/menus" element={<MenusAdminList />} />
          <Route path="/admin/roles" element={<RolesAdminList />} />
          <Route path="/admin/permissions" element={<PermissionsAdminList />} />

          <Route path="/admin/organisation-users" element={<AdminUsersList />} />
          <Route path="/admin/org-audit-log" element={<OrgAuditLog />} />
          <Route path="/admin/org-overview" element={ <PermissionGuard slug="org-overview"> <OrgOverview /> </PermissionGuard> } />
          
          <Route path="/admin/transit-visa-requirements"          element={<TransitVisaAdminList />} />
          <Route path="/admin/transit-visa-requirements/create"   element={<TransitVisaUpsertPage />} />
          <Route path="/admin/transit-visa-requirements/edit/:id" element={<TransitVisaUpsertPage />} />

          <Route path="/admin/indian-visa-requirements"          element={<IndianVisaAdminList />} />
          <Route path="/admin/indian-visa-requirements/create"   element={<IndianVisaUpsertPage />} />
          <Route path="/admin/indian-visa-requirements/edit/:id" element={<IndianVisaUpsertPage />} />

          <Route path="/admin/tickets" element={<TicketsPage />} />
          <Route path="/admin/tickets/:ticket_id" element={<TicketViewPage />} />

          <Route path="/admin/tl-leave-management"          element={<TlLeaveList />} />
          <Route path="/admin/tl-leave-management/create"   element={<TlLeaveUpsertPage />} />
          <Route path="/admin/tl-leave-management/edit/:id" element={<TlLeaveUpsertPage />} />

          <Route
            path="/admin/media-manager"
            element={<SuperadminGuard><MediaManager /></SuperadminGuard>}
          />

          <Route
            path="/admin/png-to-gif"
            element={<SuperadminGuard><PngToGifConverter /></SuperadminGuard>}
          />

          <Route path="/admin/city-images"                    element={<PermissionGuard slug="city-images"><CityImageList /></PermissionGuard>} />
          <Route path="/admin/city-images/upload"             element={<PermissionGuard slug="city-images"><CityImageUpload /></PermissionGuard>} />
          <Route path="/admin/city-images/edit/:batch_id"     element={<PermissionGuard slug="city-images"><CityImageEdit /></PermissionGuard>} />

          <Route path="/admin/popular-destinations"          element={<PermissionGuard slug="popular-destinations"><PopularDestinationList /></PermissionGuard>} />
          <Route path="/admin/popular-destinations/create"   element={<PermissionGuard slug="popular-destinations"><PopularDestinationUpsertPage /></PermissionGuard>} />
          <Route path="/admin/popular-destinations/edit/:id" element={<PermissionGuard slug="popular-destinations"><PopularDestinationUpsertPage /></PermissionGuard>} />

          <Route path="/admin/my-profile" element={<MyProfile />} />

        </Route>
      </Routes>
    </BrowserRouter>
  );
}
